export default "__VITE_ASSET__aq9knCMb__"